import { render, staticRenderFns } from "./AgencyBalance.vue?vue&type=template&id=bd1880e4&"
import script from "./AgencyBalance.vue?vue&type=script&lang=ts&"
export * from "./AgencyBalance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports